import * as Types from "../../../actions/actionTypes";

const initialState = {};

for (let i = 6; i < 13; i++) {
  initialState["sellerSalesChart" + i] = {
    loading: true,
    data: {
      chart_label: "",
      data: [],
      legends: [],
      chart_info: {
        chart_label: "",
        data: {},
      },
    },
    error: "",
  };
}

function sellerSalesChartReducer(state = initialState, action) {
  const newState = { ...state };

  for (let i = 6; i < 13; i++) {
    const chartNumber = "sellerSalesChart" + i;

    if (
      action.type ===
      Types.sellerSalesChartActionTypes[`SELLER_SALES_CHART_${i}_DATA_LOADING`]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        loading: action.payload,
      };
      return newState;
    }
    if (
      action.type ===
      Types.sellerSalesChartActionTypes[`SELLER_SALES_CHART_${i}_DATA_LOADED`]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        data: action.payload,
        error: "",
      };
      return newState;
    }
    if (
      action.type ===
      Types.sellerSalesChartActionTypes[
        `SELLER_SALES_CHART_${i}_DATA_LOAD_ERROR`
      ]
    ) {
      newState[chartNumber] = {
        ...state[chartNumber],
        error: action.payload,
      };
      return newState;
    }
  }

  if (action.type === Types.RESET_SELLER_SALES_CHART_DATA) {
    return initialState;
  }

  return state;
}

export default sellerSalesChartReducer;
